import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import MenuItem from 'components/MenuItem'
import Select from 'components/Select'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import classes from './CategoryDropdown.module.scss'

// Here we need the change event to be fired everytime, even if the value is the same,
// so we can not use select onChange and use onClick on MenuItem instead
/** @type {import("./types").default} */
const CategoryDropdown = ({ categories, selected, onSelect }) => {
  const { sendEvent } = useEventContext()
  return (
    <div className={clsx('CategoryDropdown', classes.root)}>
      <Select
        className={classes.select}
        placeHolderClasses={classes.placeHolder}
        value={selected}
        data-testid="category-dropdown"
        onChange={value => onSelect(value)}
        onClick={() =>
          sendEvent({
            engagementComponent: 'category-selector',
            name: 'engagement_facet_click',
            engagementDestination: 'expand_categories',
            engagementDetails: 'dropdown',
          })
        }
        IconComponent={() => (
          <div className={classes.icon}>
            <Icon icon={['far', 'chevron-down']} size={12} />
          </div>
        )}
      >
        {categories.map(({ label, slug }) => (
          <MenuItem key={`category-${slug}`} value={slug} data-testid="category-dropdown-item">
            <Typography variant="body-sm">{label}</Typography>
          </MenuItem>
        ))}
      </Select>
    </div>
  )
}

export default CategoryDropdown
